<div
  class="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-cover bg-center"
  style="background-image: url('/login_background1.jpg')"
>
  <div class="pointer-events-none absolute inset-0 bg-slate-900/72"></div>

  <div class="relative z-10 flex w-full flex-col items-center px-4">
    <img class="mb-8 h-10 w-auto" src="/Aksia_Logo_white.png" alt="Aksia" />

    @if (!returnUrlValid()) {
      <p class="max-w-xs text-center text-sm text-white/80">
        This page requires an active sign-in session. Please open the
        application you were using and sign in from there.
      </p>
    } @else if (suggestAuthenticator()) {
      <p class="mb-2 max-w-xs text-center text-sm font-medium text-white">
        Set up an authenticator app?
      </p>
      <p class="mb-5 max-w-xs text-center text-sm text-white/80">
        A code from an app such as Google or Microsoft Authenticator is safer
        than one by email or text, and works without a signal.
      </p>
      <div class="flex gap-3">
        <button
          type="button"
          class="rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
          (click)="setUpAuthenticator()"
        >
          Set up now
        </button>
        <button
          type="button"
          class="rounded-lg px-6 py-2.5 text-sm text-white/80 transition hover:text-white"
          (click)="continueToApp()"
        >
          Later
        </button>
      </div>
    } @else if (bounced()) {
      <p class="mb-5 max-w-xs text-center text-sm text-white/80">
        To try again, please sign in again.
      </p>
      <button
        type="button"
        class="rounded-lg bg-slate-100/95 px-6 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-200"
        (click)="goToLogin()"
      >
        Back to sign in
      </button>
    } @else {
      @if (methods().length > 1) {
        <div
          class="mb-4 flex flex-wrap justify-center gap-2"
          role="radiogroup"
          aria-label="Verification method"
        >
          @for (m of methods(); track m) {
            <button
              type="button"
              role="radio"
              [attr.aria-checked]="m === method()"
              [class]="
                'rounded-full px-3 py-1 text-xs transition ' +
                (m === method()
                  ? 'bg-white text-slate-800'
                  : 'bg-white/15 text-white/80 hover:text-white')
              "
              (click)="selectMethod(m)"
            >
              {{ labels[m] }}
            </button>
          }
        </div>
      }

      <p class="mb-5 max-w-xs text-center text-sm text-white/80">
        {{ instructions() }}
      </p>

      <form (submit)="submit($event)" novalidate>
        <div
          class="flex rounded-lg overflow-hidden shadow-[0_4px_24px_rgba(0,0,0,0.4)]"
          [class.form-shake]="formShaking()"
        >
          <input
            class="w-56 border-0 bg-white/95 py-2.5 text-center text-lg tracking-[0.3em] text-slate-900 outline-none placeholder:tracking-normal placeholder:text-slate-400"
            type="text"
            [attr.inputmode]="method() === 'RecoveryCode' ? 'text' : 'numeric'"
            autocomplete="one-time-code"
            [placeholder]="method() === 'RecoveryCode' ? 'ABCDE-12345' : 'Code'"
            [attr.maxlength]="codeMaxLength()"
            [value]="code()"
            (input)="updateCode($any($event.target).value)"
          />
          <button
            class="border-l border-slate-200 bg-slate-100/95 px-5 text-sm font-medium text-slate-700 whitespace-nowrap transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-50"
            type="submit"
            [disabled]="inFlight()"
          >
            @if (inFlight()) {
              <span
                class="block h-4 w-4 animate-spin rounded-full border-2 border-slate-400/30 border-t-slate-600"
              ></span>
            } @else {
              Verify
            }
          </button>
        </div>

        @if (showCodeError()) {
          <p class="mt-2 text-center text-xs text-rose-300">
            Please enter the verification code.
          </p>
        }

        <label
          class="mt-3 flex cursor-pointer items-center gap-2 text-xs text-white/75"
        >
          <input
            class="h-3.5 w-3.5 cursor-pointer accent-slate-300"
            type="checkbox"
            [checked]="rememberDevice()"
            (change)="rememberDevice.set($any($event.target).checked)"
          />
          <span>Remember this device</span>
        </label>

        <div
          class="mt-3 flex items-center justify-between text-xs text-white/75"
        >
          <button
            type="button"
            class="transition hover:text-white"
            (click)="goToLogin()"
          >
            Back to sign in
          </button>
          @if (canSendCode()) {
            <button
              type="button"
              class="transition hover:text-white disabled:opacity-50"
              [disabled]="sending()"
              (click)="sendCode()"
            >
              Send a new code
            </button>
          } @else {
            <a
              class="transition hover:text-white"
              href="mailto:support@aksia.com"
            >
              Contact support
            </a>
          }
        </div>
      </form>
    }
  </div>

  <footer
    class="absolute bottom-0 w-full py-4 text-center text-xs text-white/40"
  >
    <a class="transition hover:text-white/70" href="mailto:support@aksia.com">
      Contact support
    </a>
  </footer>
</div>
